(ns practitest.frontend.components.navigation2
  (:require
    [clojure.string :as str]
    [goog.object :as gobj]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.keyboard-shortcuts :as keyboard-shortcuts]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.utils :refer [development-only]]
    [practitest.frontend.components.account-layout.account-layout :as account-layout]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.navigation :as navigation :refer [current-path-includes?
                                                                      load-project-level-state!
                                                                      menu-item-element
                                                                      menu-item-header
                                                                      menu-item-separator
                                                                      project-selector]]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components.project-assistant :as project-assistant]
    [practitest.frontend.components.project-assistant.events :as-alias project-assistant.events]
    [practitest.frontend.components.project-assistant.subs :as-alias project-assistant.subs]
    [practitest.frontend.components.tooltip :as tooltip]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.dropdown :as dropdown]
    [practitest.frontend.components2.resize-panel :refer [panel-group
                                                          panel-resize-handle
                                                          panel-resizeable]]
    [practitest.frontend.components2.search-box :as search-box]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

;; Mostly copy-paste from practitest.frontend.components.navigation with slight adjustments
;; Idea is that it doesn't worth to refactor older navigation to reusable components
;; because it will eventually be replaced and it can cause regressions

(defn project-level-menu2
  [props]
  ;; Initializer
  (load-project-level-state!)

  (fn [{:keys [webcomponent? current-project user-projects] :as props}]
    (let [collapsed? @(re-frame/subscribe [::navigation/project-level-menu-collapsed?])
          ;; Need here for forced redraw when route changes during client-side navigation
          ;; otherwise active element is not updated
          current-route @(re-frame/subscribe [::router/current-route])]
      [:div.project-level-menu2
       {:class (dom/classes-pairs :collapsed collapsed?
                                  :webcomponent webcomponent?)}

       [:div.project-selector-area
        (if collapsed?
          ;; Agreed with Yafit that for collapsed bar will only show project logog
          ;; For consistent height
          [:div.project-selector.collapsed-project-icon
           [navigation/project-icon current-project]]

          [project-selector
           (select-keys props
                        [:current-project
                         :current-account
                         :user-projects
                         :webcomponent?
                         :on-project-pin-clicked])])]

       [:div.project-menu-scrollable-container
        [menu-item-header {:text (get-translation "navigation.project-menu.main-modules" "Main Modules")
                           :icon icons/mux-union
                           :collapsed? collapsed?}]
        (let [uri (broutes/get-url-view "milestones#index")]
          (when (permissions/has-permission? "milestones_view")
            [menu-item-element {:text (get-translation "navigation.project-menu.milestones" "Milestones")
                                :id "project-menu-milestones"
                                :test-id "project-menu-milestones"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-milestones
                                :collapsed? collapsed?}]))
        (let [uri (broutes/get-url-view "requirements#index")]
          (when (permissions/has-permission? "requirements_view")
            [menu-item-element {:text (get-translation "navigation.project-menu.requirements" "Requirements")
                                :id "project-menu-requirements"
                                :test-id "project-menu-requirements"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-requirements
                                :collapsed? collapsed?}]))
        (let [uri (broutes/get-url-view "qtest_designs#index")]
          (when (permissions/has-permission? "tests_runs_view")
            [menu-item-element {:text (get-translation "navigation.project-menu.test-library" "Test Library")
                                :id "project-menu-test-library"
                                :test-id "project-menu-test-library"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-test-library
                                :collapsed? collapsed?}]))
        (let [uri (broutes/get-url-view "suites#index")]
          (when (permissions/has-permission? "tests_runs_view")
            [menu-item-element {:text (get-translation "navigation.project-menu.testsets" "Test Sets & Runs")
                                :id "project-menu-testsets"
                                :test-id "project-menu-testsets"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-testsets-runs
                                :collapsed? collapsed?}]))
        (let [uri (broutes/get-url-view "issues#index")]
          (when (permissions/has-permission? "issues_view")
            [menu-item-element {:text (get-translation "navigation.project-menu.issues" "Issues")
                                :id "project-menu-issues"
                                :test-id "project-menu-issues"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-issues
                                :collapsed? collapsed?}]))

        [:div.menu-spacer]

        ;; TODO: spacer or just increase margin-bottom ?
        [menu-item-header {:text (get-translation "navigation.project-menu.project-info" "Project Info")
                           :icon icons/mux-project-info
                           :collapsed? collapsed?}]

        (let [uri (broutes/get-url-view "summary#index")]
          [menu-item-element {:text (get-translation "navigation.project-menu.dashboards" "Dashboards")
                              :id "project-menu-dashboards"
                              :test-id "project-menu-dashboards"
                              :href uri
                              :active? (current-path-includes? uri)
                              :icon icons/mux-dashboards
                              :collapsed? collapsed?}])
        (let [uri (broutes/get-url-view "kanban#index" {:p_id (:id current-project)})]
          [menu-item-element {:text (get-translation "navigation.project-menu.taskboard" "Task Board")
                              :id "project-menu-taskboard"
                              :test-id "project-menu-taskboard"
                              :href uri
                              :active? (current-path-includes? uri)
                              :icon icons/mux-taskboard
                              :collapsed? collapsed?}])
        (let [uri (broutes/get-url-view "reports#index")]
          (when (permissions/has-permission? "reports")
            [menu-item-element {:text (get-translation "navigation.project-menu.reports" "Reports")
                                :id "project-menu-reports"
                                :test-id "project-menu-reports"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-reports
                                :collapsed? collapsed?}]))
        (let [uri (broutes/get-url-view "histories#index" {:project_id (:id current-project)})]
          (when (permissions/has-permission? "users_n_per")
            [menu-item-element {:text (get-translation "navigation.project-menu.project-history" "Project History")
                                :id "project-menu-project-history"
                                :test-id "project-menu-project-history"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-project-history
                                :collapsed? collapsed?}]))
        (if (permissions/has-permission? "users_n_per")
          (let [uri (broutes/get-url-view "projects#edit" {:id (:id current-project)})]
            [menu-item-element {:text (get-translation "navigation.project-menu.project-settings" "Project Settings")
                                :id "project-menu-project-settings"
                                :test-id "project-menu-project-settings"
                                :href uri
                                ;; TODO: fix this - right now I'm enumerating all possible tab uris
                                :active? (let [project-base-uri (str "/projects/" (:id current-project))
                                               project-base-uri2 (str "/p/" (:id current-project))
                                               available-urls #{(str project-base-uri "/edit")
                                                                (str project-base-uri2 "/edit")
                                                                (str project-base-uri "/automation")
                                                                (str project-base-uri "/integration_settings")
                                                                (str project-base-uri "/custom_views")
                                                                (str project-base-uri "/sections")
                                                                (str project-base-uri "/custom_fields")
                                                                (str project-base-uri "/step_params")
                                                                (str project-base-uri "/workflow_editor")
                                                                (str project-base-uri2 "/dashboards")
                                                                (str project-base-uri "/groups")
                                                                (str project-base-uri "/import")}
                                               current-path (str/lower-case (dom/get-current-path))]
                                               (or (contains? available-urls current-path)
                                                   (re-matches (re-pattern (str project-base-uri2 "/dashboard_items/\\d+/edit")) current-path)
                                                   (re-matches (re-pattern (str project-base-uri2 "/dashboards/\\d+")) current-path)
                                                   (re-matches (re-pattern (str project-base-uri2 "/dashboard_items/new.*")) current-path)))
                                :icon icons/mux-project-settings
                                :collapsed? collapsed?}])
          ;; For Testers - different uri
          (let [uri (broutes/get-url-view "custom_views#index")]
            [menu-item-element {:text (get-translation "navigation.project-menu.project-settings" "Project Settings")
                                :id "project-menu-project-settings"
                                :test-id "project-menu-project-settings"
                                :href uri
                                :active? (current-path-includes? uri)
                                :icon icons/mux-project-settings
                                :collapsed? collapsed?}]))

        (development-only
          [practitest.frontend.components.navigation/developer-section collapsed?])]

       [:div.close-button
        (-> {:class (dom/classes-pairs :collapsed collapsed?)
             :on-click (fn []
                         (re-frame/dispatch [::navigation/set-project-level-menu-collapsed? (not collapsed?)]))}
            (dom/add-test-id "project-menu-close-btn"))
        (when-not collapsed?
          [:span (get-translation "generic.label.close" "Close")])
        [:div.arrow-close
         (if collapsed?
           [icons/mux-arrow-right]
           [icons/mux-arrow-left])]]])))

(defn- header-settings-button
  [current-account]
  [tooltip/mux-tooltip
   {:position "bottom"}
   (get-translation "navigation.settings-menu.tooltip" "Settings")
   (fn [props]
     [:a.header-bar2-icon
      (assoc props :id "header-bar-icon-global"
                   :target  "_blank"
                   :href (broutes/get-url "account/accounts#settings" {:account_id (:id current-account)}))
      [icons/mux-gear]])])

(defn- header-back-to-pt-app-button [current-account]
  (let [back-app-url (str "/?account_id=" (:id current-account))]
    [buttons/button {:tertiary? true
                     :href back-app-url
                     :text (get-translation "navigation.header-bar.back-to-pt-button" "Back to PractiTest")
                     :class "back-to-pt-app"
                     :icon [icons/mux-arrow-left2]}]))

(defn header-bar-buttons2
  [options]
  (let [root-ref (atom nil)
        main-menu-ref (atom nil)
        submenu-overlay-state (reagent/atom {})
        modal-open?           (reagent/atom false)
        setting-button? (not (:account-settings? options))
        back-to-pt-app-button? (:account-settings? options)]
    (fn [{:keys [webcomponent?] :as options}]
      [:div.header-bar2-buttons
       {:class (dom/classes-pairs :webcomponent webcomponent?)
        :ref (dom/root-ref-handler root-ref)}

       (let [user-accounts (:user-accounts options)
             current-account (:current-account options)
             current-user-account (first (filter #(= (:id (:account %))
                                                     (:id current-account))
                                                 user-accounts))]
         (cond
           (and setting-button? (:is_owner current-user-account))
           [header-settings-button current-account]
           back-to-pt-app-button?
           [header-back-to-pt-app-button current-account]))

       (let [ai-consent? @(re-frame/subscribe [::subs/generative-ai-consent?])
             assistant-enabled? @(re-frame/subscribe [::subs/project-assistant-enabled?])
             ;; XXX: this is ugly
             in-project? (or (str/starts-with? (.-pathname js/window.location) "/p/")
                             (str/starts-with? (.-pathname js/window.location) "/projects/"))]
         (when (and ai-consent? assistant-enabled? in-project?)
           [tooltip/mux-tooltip
            {:position "bottom"}
            "Project Assistant"
            (fn [props]
              [:div.header-bar2-icon
               (assoc props :on-click #(re-frame/dispatch [::project-assistant.events/toggle-panel]))
               [icons/mux-smart-fox2]])]))

       (let [hide! (fn []
                     (swap! submenu-overlay-state assoc :show-help-menu? false))
             toggle! (fn []
                       (swap! submenu-overlay-state update :show-help-menu? not))
             show? (:show-help-menu? @submenu-overlay-state)]
         [overlay2/floating-ui-overlay
          {:placement        "bottom-end"
           :offset           5
           :on-request-close hide!
           :show?            show?}

          [tooltip/mux-tooltip
           {:position "bottom"}
           (get-translation "navigation.help-menu.help" "Help")
           (fn [props]
             [:div.header-bar2-icon
              (-> props
                  (dom/add-test-id "account-menu-help")
                  (assoc :on-click (fn [_]
                                     (toggle!))))
              [icons/mux-circle-question-mark]])]
          [:div.menu-popup
           [menu-item-element {:text        (get-translation "navigation.help-menu.help-center" "Help Center")
                               :id          "help-menu-help-center"
                               :href        broutes/help-menu-help-center-url
                               :new-window? true
                               :mixpanel    ["Question mark - help center"]
                               :icon        icons/mux-information-ask}]
           [menu-item-element {:text        (get-translation "navigation.help-menu.discussion-forums" "Discussion Forums")
                               :id          "help-menu-discussions-forums"
                               :href        broutes/help-menu-discussions-forum-url
                               :new-window? true
                               :mixpanel    ["Question mark - discussion forums"]
                               :icon        icons/mux-discussion-icon}]
           [menu-item-element {:text     (get-translation "navigation.help-menu.tutorials" "Tutorials")
                               :id       "help-menu-tutorials"
                               :href     (broutes/get-url "tutorials#index")
                               :mixpanel ["Question mark - tutorials"]
                               :icon     icons/mux-tutorials}]
           [menu-item-element {:text        (get-translation "navigation.help-menu.feature-request" "Feature Request")
                               :id          "help-menu-feature-request"
                               :href        broutes/help-menu-feature-request-url
                               :new-window? true
                               :mixpanel    ["Question mark - feature request"]
                               :icon        icons/mux-letter}]
           [menu-item-element {:text        (get-translation "navigation.help-menu.get-certified" "Get Certified!")
                               :id          "help-menu-get-certified"
                               :on-click    (fn [_]
                                              (reset! modal-open? true))
                               :mixpanel    ["Question mark - get certified"]
                               :icon        icons/mux-certification}]]])
       [navigation/certification-modal root-ref modal-open?]

       (let [user-accounts (:user-accounts options)
             current-user (:current-user options)
             current-account (:current-account options)
             current-project (:current-project options)
             single-account? (= 1 (count user-accounts))

             hide! (fn []
                     (swap! submenu-overlay-state assoc :show-account-menu? false))
             toggle! (fn []
                       (swap! submenu-overlay-state update :show-account-menu? not))
             show? (:show-account-menu? @submenu-overlay-state)
             ff-navigate-fn (fn [e params]
                              (dom/prevent-default e)
                              (dom/post-navigate! (broutes/get-url-view "projects#user_toggle_feature"
                                                                        {:id (:id current-project)
                                                                         :user_id (:id current-user)
                                                                         :feature (:feature params)}
                                                                        {:default (:default params)})))]
         [overlay2/floating-ui-overlay
          {:placement        "bottom-end"
           :offset           10
           :show?            show?
           ;:trace?           true
           :on-request-close hide!}
          ;; Target
          [tooltip/mux-tooltip
           {:position "bottom-end"}
           (:name current-user)
           (fn [props]
             [:div
              (assoc props
                     :id "account-menu-avatar"
                     :on-click (fn [_]
                                 (toggle!)))

              [:div.avatar-and-badge-container2
               (when (:certified current-user)
                 [:div.badge-with-straps
                  [icons/mux-certified-badge-with-straps]])
               [navigation/user-avatar2 current-user]]])]

          ;; Body
          [:div.menu-popup.account-menu-nav2
           {:class (dom/classes-pairs :expanded-to-left (:show-account-submenu? @submenu-overlay-state))
            ;; Store ref to reuse it later
            :ref   (fn [node]
                     (when node
                       (reset! main-menu-ref node)))}

           (if single-account?
             [:<>
              [menu-item-element {:text       (:name current-account)
                                  :read-only? true
                                  :primary?   true
                                  :icon       icons/mux-circle-user}]
              [menu-item-separator {:class "single-account-separator"}]]

             (let [hide! (fn []
                           (swap! submenu-overlay-state assoc :show-account-submenu? false))
                   toggle! (fn []
                             (swap! submenu-overlay-state update :show-account-submenu? not))
                   show? (:show-account-submenu? @submenu-overlay-state)]
               [menu-item-element {:text            "Switch Account"
                                   :id              "account-menu-switch-account"
                                   :on-click        (fn [e]
                                                      (toggle!)
                                                      ;; When click is not from our submenu (react propagates events
                                                      ;; even if child is actually rendered in portal)
                                                      (when-not (gobj/get e "_from_submenu")
                                                        ;; Otherwise it would hide everything
                                                        (dom/stop-propagation e)))
                                   ;; nested overlay
                                   :additional-item [overlay2/floating-ui-overlay
                                                     {:placement        "left-start"
                                                      :target           main-menu-ref
                                                      ;; Rendering into portal, otherwise there would be some
                                                      ;; interesting visual effects
                                                      :container        root-ref
                                                      :show?            show?
                                                      :on-request-close hide!}
                                                     ;; Target
                                                     [:span.dropdown-chevron
                                                      [icons/mux-chevron-right2]]
                                                     ;; Body
                                                     [:div.menu-popup
                                                      {:class (dom/classes-pairs :expanded-from-right true)}
                                                      (for [user-account user-accounts
                                                            :let [account (:account user-account)
                                                                  current? (= (:id account)
                                                                              (:id current-account))
                                                                  href (broutes/get-url "sessions#change_account_to_landing"
                                                                                        {}
                                                                                        {:account_id (:id account)})]]
                                                        ^{:key (:id account)}
                                                        [menu-item-element {:text            (:name account)
                                                                            :mixpanel        ["Switch Account"]
                                                                            :active?         current?
                                                                            :additional-item (when current?
                                                                                               [:span.active-icon
                                                                                                [icons/mux-checkbox]])
                                                                            :on-click        (fn [e]
                                                                                               ;; We want to close parent menu too when
                                                                                               ;; clicking on this item here. Will be propagated to parent handler
                                                                                               (gobj/set e "_from_submenu" true))
                                                                            :href            href}])]]
                                   :icon            icons/mux-circle-user}]))
           [dropdown/dropdown-menu-item {:text (get-translation "navigation.settings-menu.personal-settings"
                                                                "Personal settings")
                                         :id "account-menu-personal-settings"
                                         :href (broutes/get-url "personals#index")
                                         :icon [icons/mux-gear-cutout]}]
           [dropdown/dropdown-menu-item {:text (get-translation "navigation.settings-menu.logout" "Logout")
                                         :id "account-menu-logout"
                                         :href (broutes/get-url "sessions#destroy")
                                         :icon [icons/mux-door-exit]}]]])])))

(defn header-bar2
  [options]
  (reagent/with-let [search-box-ref (atom nil)]
    [:div.header-bar2
     [keyboard-shortcuts/add-goto-shortcuts]
     [keyboard-shortcuts/add-shortcut
      {:shortcut [:global :focus-on-search]
       :handler (fn [] (dom/focus-on-ref! search-box-ref false))}]
     [:a.main-logo
      {:id "account-menu-logo"
       :href (str "/?account_id=" (:id (:current-account options)))}
      [icons/new-practitest-logo]]

     [search-box/search-box-component options search-box-ref]
     [header-bar-buttons2 options]]))

(defn account-setting-path? []
  (let [current-path (.-pathname (.-location js/window))
        account-setting-regex #"^/accounts/\d+/.*$"]
    (boolean (re-matches account-setting-regex current-path))))

(defn body-with-assistant [_body]
  (let [panel-ref (atom nil)
        sync-panel! (fn []
                      (when-let [p @panel-ref]
                        (if @(re-frame/subscribe [::project-assistant.subs/panel-open?])
                          (.expand p)
                          (.collapse p))))]
    (reagent/create-class
      {:display-name "body-with-assistant"
       :component-did-mount (fn [_] (sync-panel!))
       :component-did-update (fn [_] (sync-panel!))
       :reagent-render
       (fn [body]
         (let [panel-open? @(re-frame/subscribe [::project-assistant.subs/panel-open?])]
           [:div.assistant-resizable-container
            [panel-group {:auto-save-id "body-and-assistant"}
             [panel-resizeable {:default-size 70 :min-size 40}
              [:div.main-body2 body]]
             [panel-resize-handle
              {:class (when-not panel-open? "resize-handle-hidden")}]
             [panel-resizeable {:default-size 30
                                :min-size 20
                                :collapsible true
                                :collapsed-size 0
                                :panel-ref #(reset! panel-ref %)}
              [project-assistant/assistant-panel]]]]))})))

(defn navigation-layout2
  [body options]
  (let [new-account-settings? (account-setting-path?)]
    [:<>
     [notifications/toast-container]
     (cond
       new-account-settings?
       [:div.main-window2
        [account-layout/account-settings-header (assoc options :webcomponent? true :account-settings? true) header-bar-buttons2]
        [navigation/system-messages-bar (assoc options :current-user-account (some #(when (= (:id (:account %)) (:id (:current-account options))) %) (:user-accounts options)))]
        [:div.menu-and-body-container2
         [account-layout/account-settings-panel (assoc options :webcomponent? true)]
         [:div.main-body2 body]]]

       :else
       [:div.main-window2
        [header-bar2 options]
        [navigation/system-messages-bar (assoc options :current-user-account (some #(when (= (:id (:account %)) (:id (:current-account options))) %) (:user-accounts options)))]
        [:div.menu-and-body-container2
         [project-level-menu2 options]
         (if (project-assistant/assistant-available?)
           [body-with-assistant body]
           [:div.main-body2 body])]])]))
